<template>
  <div class="wait-times">
    <div v-if="!loaded">
      Loading wait times...
      <br><br>
    </div>

    <div
      v-if="loaded"
      class="locations"
    >
      <WaitTimeLocation
        v-for="location in locations"
        :key="location.name"
        :location="location"
        :wait-data="getFetchedLocation(location.location_id)"
        :wait-data-unavailable="!!fetchError"
        @reserve="openReserve(arguments[0])"
      />
    </div>

    <div
      ref="dialog"
      class="dialog"
      aria-hidden="true"
    >
      <div
        class="dialog-overlay"
        tabindex="-1"
        data-a11y-dialog-hide
      />
      <div
        class="dialog-content"
        role="dialog"
        aria-labelledby="dialog-title"
      >
        <div role="document">
          <button
            type="button"
            class="dialog-close"
            data-a11y-dialog-hide
            aria-label="Close this dialog window"
          >
            &times;
          </button>

          <h1 id="dialog-title">
            Schedule Online
          </h1>

          <Reserve
            v-if="iframeUrl"
            :iframe-url="iframeUrl"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import find from 'lodash/find';
// import swal from 'sweetalert2';
import A11yDialog from 'a11y-dialog';
import WaitTimeLocation from './WaitTimeLocation';
import Reserve from './Reserve';

export default {
  name: 'WaitTimes',
  components: {
    WaitTimeLocation,
    Reserve,
  },

  data() {
    return {
      loaded: false,
      fetchedLocations: [],
      fetchError: false,
      iframeUrl: null,
    };
  },

  computed: {
    locations() {
      return this.$store.getters.filteredLocations;
    },
  },

  created() {
    this.dialog = null;
    this.fetchTimes();
    setInterval(() => {
      this.fetchTimes();
    }, 120000);
  },

  mounted() {
    this.$nextTick(() => {
      // eslint-disable-next-line
      this.dialog = new A11yDialog(this.$refs.dialog);
    });
  },

  methods: {
    fetchTimes() {
      const sup = window.location.hash.indexOf('sup') !== -1;

      axios.get(`https://api.caldwellwaittimes.com/${sup ? '?sup' : ''}`)
        .then((response) => {
          this.fetchedLocations = response.data;
        })
        .catch(() => {
          this.fetchError = true;
          // swal('Error', 'Unable to fetch wait times. Please wait a few minutes or reload the page.', 'error')
          //   .catch(swal.noop);
        })
        .then(() => {
          this.loaded = true;
        });
    },

    getFetchedLocation(locationId) {
      return find(this.fetchedLocations, (location) => parseInt(location.id, 10) === parseInt(locationId, 10));
    },

    openReserve(iframeUrl) {
      if (this.dialog) {
        this.iframeUrl = iframeUrl;
        this.dialog.show();
      }
    },
  },
};
</script>

<style lang="scss">
.locations {
  margin-bottom: 3rem;
  margin-top: 1rem;
  @media screen and (min-width: 768px) {
    margin-top: 2rem;
  }
}

.dialog[aria-hidden='true'] {
  display: none;
}

.dialog-overlay {
  background-color: rgba(43, 46, 56, 0.9);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;
}

.dialog-content {
  background-color: rgb(255, 255, 255);
  border-radius: 2px;
  height: 100%;
  left: 50%;
  max-height: 100%;
  max-width: 100%;
  overflow-y: auto;
  padding: 1em;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  z-index: 3;
  @media screen and (min-width: 768px) {
    max-height: 90%;
    max-width: 90%;
    padding: 2rem;
  }
}

.dialog h1 {
  font-size: 1.25em;
  margin: 0 0 2rem;
}

.dialog-close {
  background-color: transparent;
  border: 0;
  cursor: pointer;
  font-size: 1.5em;
  font-weight: bold;
  height: 1.5em;
  padding: 0;
  right: .5em;
  position: absolute;
  text-align: center;
  transition: 0.15s;
  top: .5em;
  width: 1.5em;
  @media screen and (min-width: 768px) {
    right: 1em;
    top: 1em;
  }
}
</style>
